/* Decorative image strip only: never modifies the media or slideshow controls. */
if (!customElements.get('ghost-gallery-glass')) {
  customElements.define('ghost-gallery-glass', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.gallery = this.closest('media-gallery');
      if (!this.gallery) return;
      const gallery = this.gallery;
      if (getComputedStyle(gallery).position === 'static') gallery.setAttribute('data-ghost-glass-static', '');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      const options = { signal: this.events.signal, capture: true, passive: true };
      gallery.addEventListener('scroll', this.schedule, options);
      gallery.addEventListener('load', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(gallery, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['aria-hidden', 'aria-selected', 'hidden', 'src', 'srcset', 'poster', 'data-image']
      });
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(gallery);
      this.update();
    }
    update() {
      if (!this.isConnected) return;
      const gallery = this.gallery;
      gallery.removeAttribute('data-ghost-glass-static');
      if (getComputedStyle(gallery).position === 'static') gallery.setAttribute('data-ghost-glass-static', '');
      const grid = gallery.querySelector(':scope > .media-gallery__grid');
      let media;
      if (grid?.getClientRects().length && getComputedStyle(grid).display !== 'none') {
        media = [...grid.children].find(item => item.getClientRects().length);
      } else {
        const slides = [...gallery.querySelectorAll('slideshow-slide.product-media-container')]
          .filter(item => !item.closest('dialog') && item.getClientRects().length);
        // Find the slide nearest its scrolling viewport centre, including during swipes.
        let distance = Infinity;
        for (const slide of slides) {
          const viewport = slide.closest('slideshow-slides, slideshow-container')?.getBoundingClientRect();
          const rect = slide.getBoundingClientRect();
          if (!viewport || !rect.width || !rect.height) continue;
          const next = Math.abs((rect.left + rect.right) / 2 - (viewport.left + viewport.right) / 2);
          if (next < distance) { distance = next; media = slide; }
        }
      }
      const img = media?.querySelector('img');
      const video = media?.querySelector('video');
      const source = img?.currentSrc || img?.getAttribute('src') || video?.poster || this.dataset.image;
      if (!source) { gallery.removeAttribute('data-ghost-glass-ready'); return; }
      try {
        const url = new URL(source, location.href);
        if (!['https:', 'http:'].includes(url.protocol)) return;
        if (this.source !== url.href) {
          this.style.setProperty('--ghost-gallery-image', `url(${JSON.stringify(url.href)})`);
          this.source = url.href;
        }
        gallery.setAttribute('data-ghost-glass-ready', '');
      } catch (_) { /* Leave the last valid decorative image in place. */ }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.gallery?.removeAttribute('data-ghost-glass-ready');
      this.gallery?.removeAttribute('data-ghost-glass-static');
    }
  });
}
